import { StyledSpan } from './styled.js';
import { jsx } from 'react/jsx-runtime';

function Text(props) {
  var children = props.children,
    _props$size = props.size,
    size = _props$size === void 0 ? 'small' : _props$size,
    _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'default' : _props$appearance,
    _props$weight = props.weight,
    weight = _props$weight === void 0 ? 'normal' : _props$weight,
    className = props.className;
  return /*#__PURE__*/jsx(StyledSpan, {
    $size: size,
    $appearance: appearance,
    $weight: weight,
    className: className,
    children: children
  });
}

export { Text as default };
